import TemplateView from '../../../../../TemplateView'
import messageResource from '../../../../../messageResource'
import CircleSpinner from '../../../../../components/spinner/CircleSpinner'
import {hostingZone} from '../../../constants'

export default class ProcessingContent extends TemplateView {

    constructor() {
        super()

        this.state = {
            hostingZone: '',
            context: '',
        }

        this.onStatePropertyChanged('hostingZone', (hostingZone) => {
            this.$hostingZoneTransfer.text(messageResource.getMessage('licenses.purchase.success.wait.transfer_title', [this._getNameHostingZone(hostingZone)]))
        })

        this.onAnyStatePropertyChanged(['context', 'hostingZone'], () => {
            this.$effectTitle.text(
                messageResource.getMessage('licenses.purchase.success.wait.actitime_link_title', [this.state.hostingZone, this.state.context]))
        })
    }

    templateHtml() {
        return '<div class="container">' +
               '    <div class="processingTitle"><%=processingTitle%></div>' +
               '    <div class="spinner"/>' +
               '    <div class="hostingZoneTransfer"/>' +
               '    <div class="effectTitle"/>' +
               '</div>'
    }

    messageKeys() {
        return {
            processingTitle: 'licenses.purchase.success.wait.title',
        }
    }

    afterRender() {
        this.$hostingZoneTransfer = this.find('.hostingZoneTransfer')
        this.$effectTitle = this.find('.effectTitle')
        new CircleSpinner({
            additionalClassCircle: 'additionalClassCircle',
            additionalClassContainer: 'additionalClassContainer',
        }).init(this.find('.spinner'))
    }

    _getNameHostingZone(zone) {
        if (zone === hostingZone.EUROPE) {
            return messageResource.getMessage('hosting_zone.europe')
        }

        return messageResource.getMessage('hosting_zone.north_america')
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/successStep/ProcessingContent.js